

import React from 'react';
import './Popular.css';
import data_product from '../Assets/data';
import Item from '../Item/Item';

const Popular = () => {
  return (
    <div className='container popular'>
      <h3 className="text-center mt-4" style={{color:"#ff6518"}}>POPULAR IN WOMEN</h3>
      <hr className="mb-4" />
      
      {/* Grid with responsive layout */}
      <div className="row row-cols-2 row-cols-md-3 g-4">
        {data_product.map((item, i) => (
          <div key={i} className="col">
            <Item 
              id={item.id} 
              name={item.name} 
              image={item.image} 
              new_price={item.new_price} 
              old_price={item.old_price} 
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Popular;

